import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=b50208ce&scoped=true&"
import script from "./AddTask.vue?vue&type=script&lang=ts&"
export * from "./AddTask.vue?vue&type=script&lang=ts&"
import style0 from "./AddTask.vue?vue&type=style&index=0&id=b50208ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50208ce",
  null
  
)

export default component.exports